/**
 * Static UI chrome shared across the app pages — the sidebar nav and the
 * upload→assembly progress steps. These are product
 * configuration (not trial/test seed data), so production feature code may
 * import them. Trial/test *seed* data lives in `sample-data.ts` and is for
 * Storybook/tests only (see the SC-003 hygiene gates).
 */

import type { OwnerChooserUser } from '../components/OwnerChooser';
import type {
  ProjectExportAvailability,
  ProjectPrimaryAction,
  ProjectReviewProgress,
  ProjectStatus,
} from '../components/ProjectCard';

// Settings is intentionally absent for now — there is no settings surface yet.
export const NAV_ITEMS = [
  { id: 'dashboard', label: 'Dashboard', icon: 'dashboard' as const },
  { id: 'uat', label: 'UAT Script Generator', icon: 'fileText' as const },
  { id: 'team', label: 'Team', icon: 'team' as const },
];

export const UPLOAD_STEPS = [
  { id: 'upload', label: 'Upload' },
  { id: 'verification', label: 'Verification' },
  { id: 'assembly', label: 'Assembly' },
  { id: 'finish', label: 'Finish' },
];

/** A row in the Script Package Dashboard's project grid. */
export type ProjectRow = {
  id: string;
  title: string;
  /** Owned by the signed-in viewer — drives the "My Projects" tab. */
  mine?: boolean;
  status: ProjectStatus;
  buildLabel: string;
  /** F-139: the Owner as a full UserSummary so the card can render the picker. */
  owner: OwnerChooserUser;
  reviewer: string;
  createdBy: string;
  updatedLabel: string;
  reviewProgress?: ProjectReviewProgress;
  latestFinalisedVersion?: string;
  primaryAction?: ProjectPrimaryAction;
  exportAvailability?: ProjectExportAvailability;
  /** F-033 (R5): the non-blocking "needs confirmation" cue for a provisional name. */
  needsNameConfirmation?: boolean;
};
